import { useLocalStorage } from '@mantine/hooks';

export const VERDICTS = ['', 'not_spam', 'spam'] as const;
export type Verdict = (typeof VERDICTS)[number];

export const PERIODS = ['7', '30', 'all'] as const;
export type Period = (typeof PERIODS)[number];

export const isVerdict = (v: unknown): v is Verdict => VERDICTS.includes(v as Verdict);
export const isPeriod = (v: unknown): v is Period => PERIODS.includes(v as Period);

export const isSpamFor = (v: Verdict) => (v === '' ? undefined : v === 'spam');

/** Spam / not spam / both, shared by every message list; spam stays hidden until asked for. */
export function useVerdictPreference(): [Verdict, (v: Verdict) => void] {
  const [value, set] = useLocalStorage<Verdict>({
    key: 'formshive.messages.verdict',
    defaultValue: 'not_spam',
    getInitialValueInEffect: false,
  });
  return [isVerdict(value) ? value : 'not_spam', set];
}

export function usePeriodPreference(): [Period, (p: Period) => void] {
  const [value, set] = useLocalStorage<Period>({
    key: 'formshive.messages.period',
    defaultValue: '7',
    getInitialValueInEffect: false,
  });
  return [isPeriod(value) ? value : '7', set];
}
